import React from 'react';
import { usePermissions } from '../../contexts/PermissionsContext';

/**
 * Badge stock POS V2 — spec UX :
 * - « M2 · local » plein quand stock session
 * - « Stock M1 » bordure ambre quand vente cross-magasin
 */
const PosV2StockBadge = ({ sessionMag, stockMag, stockLocal, size = 'sm' }) => {
  const { getMagasinColor } = usePermissions();
  const localQty = Number(stockLocal ?? 0);
  const isLocal = stockMag === sessionMag && localQty > 0;
  const pad = size === 'md' ? 'px-2.5 py-1 text-xs' : 'px-2 py-0.5 text-[10px]';

  if (isLocal) {
    const color = getMagasinColor(sessionMag);
    return (
      <span
        className={`inline-flex items-center font-bold uppercase rounded-md ${pad}`}
        style={{ backgroundColor: color, color: '#fff' }}
        title={`Stock local ${sessionMag}`}
      >
        {sessionMag} · local
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center font-bold uppercase rounded-md border border-amber-500/70 text-amber-200 bg-amber-950/40 ${pad}`}
      title={`Stock magasin ${stockMag}`}
    >
      Stock {stockMag}
    </span>
  );
};

export default PosV2StockBadge;
